import { Cancel as CloseIcon, SearchIcon } from '@arvesta-websites/icons';
import React from 'react';
import { useIntl } from 'react-intl';

import { withErrorBoundary } from '../../../ErrorBoundary';

import { StyledClosedButton, StyledInput, StyledSearchIconButton, StyledWrapper } from './Styled';

type SearchLightProps = {
  searchFunction: (searchTerm: string) => void;
  variant?: string;
};

export const SearchLight = ({ searchFunction, variant }: SearchLightProps) => {
  const [searchTerm, setSearchTerm] = React.useState('');
  const [focused, setFocusedState] = React.useState(false);
  const inputRef = React.createRef<HTMLInputElement>();
  const intl = useIntl();

  React.useEffect(() => {
    if (!focused) {
      setSearchTerm('');
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    }
  }, [focused, setSearchTerm, inputRef]);

  return (
    <StyledWrapper className={`${focused ? 'focused-input' : ''}`} variant={variant}>
      <StyledSearchIconButton
        onClick={() => {
          if (focused) {
            searchFunction(searchTerm);
          }
        }}
        onKeyDown={() => {
          if (focused) {
            searchFunction(searchTerm);
          }
        }}
        role="button"
        tabIndex={0}
        variant={variant}
      >
        <SearchIcon />
      </StyledSearchIconButton>
      <StyledInput
        autoComplete="off"
        name="search"
        onBlur={() => setFocusedState(false)}
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          setSearchTerm(e.currentTarget.value);
          setFocusedState(true);
        }}
        onFocus={() => setFocusedState(true)}
        onKeyDown={e => {
          if (e.keyCode === 27) {
            setFocusedState(false);
          }
        }}
        onKeyUp={e => {
          if (e.key === 'Enter') {
            searchFunction(searchTerm);
          }
        }}
        placeholder={intl.formatMessage({ id: 'header.search.placeholder' })}
        ref={inputRef}
        role="search"
      />
      {focused ? (
        <StyledClosedButton
          onClick={() => setFocusedState(false)}
          onKeyDown={() => {
            searchFunction(searchTerm);
          }}
          role="button"
          tabIndex={0}
          variant={variant}
        >
          <CloseIcon />
        </StyledClosedButton>
      ) : null}
    </StyledWrapper>
  );
};

export default withErrorBoundary(SearchLight, { componentName: 'SearchLight' });
